import React, { use, useCallback, useEffect, useState } from "react";
import { Form, Input, Select, Button, Typography, Radio, message, Col, Row, Popconfirm, Modal, Spin } from "antd";
import "../styles/AddNewDeal.css";
import axiosInstance from "../axios";
import Autocomplete from "react-google-autocomplete";
import { useAtom } from "jotai";
import { citysList } from "../states/citys";
import { CourseCategories } from "../components/constants";
import ReactGoogleAutocomplete from "react-google-autocomplete";
const { Option } = Select;
const { Title } = Typography;

// Serviceable cities offered in the "State" dropdown. These map to NewCity rows on
// the backend (city_name -> city_id), so the value sent must come from this list.
const SERVICEABLE_CITIES = [
  "Hyderabad",
  "Bangalore",
  "Mysore",
  "Pune",
  "Dehradun",
  "Raipur/Bhilai/Durg",
  "Chennai",
  "Vijayawada",
  "Mumbai",
  "Gurgaon",
  "Delhi",
  "Mysore",
  "Ahmedabad",
  "Ghaziabad",
  "Faridabad",
  "Noida",
  "Kolkata",
  "Other",
];

// Pick the first candidate (city / admin area / locality from Google) that matches a
// serviceable city, case-insensitively. Returns "" when none match so the dropdown
// is cleared rather than left on a stale city.
const matchServiceableCity = (...candidates) => {
  for (const candidate of candidates) {
    if (!candidate) continue;
    const match = SERVICEABLE_CITIES.find(
      (city) => city.toLowerCase() === String(candidate).trim().toLowerCase(),
    );
    if (match) return match;
  }
  return "";
};

const AddNewDeal = () => {
  const [form] = Form.useForm();
  const [isReadonly, setIsReadonly] = useState(false);
  const [classReadonly, setClassReadonly] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [courseData, setCourseData] = useState([]);
  const Categories = CourseCategories;
  const [citys, _setCitys] = useAtom(citysList);
  const [formData, setFormData] = useState([
    {
      name: "Lead Type",
      type: "radio",
      options: ["Call"],
    },
    {
      section: "Personal Details",
      fields: [
        { type: "text", name: "firstName", label: "First Name", placeholder: "Enter Your First Name" },
        { type: "text", name: "lastName", label: "Last Name", placeholder: "Enter Your Last Name" },
        {
          type: "dropDown",
          name: "gender",
          label: "Gender",
          options: ["Male", "Female"],
          placeholder: "Select Gender",
        },
        { type: "text", name: "email", label: "Email Address", placeholder: "Enter Your Email Address" },
        { type: "text", name: "mobile", label: "Mobile Number", placeholder: "Enter Your 10 Digit Mobile Number" },
        {
          type: "dropDown",
          name: "state",
          label: "State",
          options: SERVICEABLE_CITIES,
          placeholder: "Select",
        },
        { type: "text", name: "location", label: "Location", placeholder: "Location Pin code Latitude/Longitude" },
      ],
    },
    {
      section: "Class Preference",
      fields: [
        {
          type: "dropDown",
          name: "areaOfStudy",
          label: "Choose Area of Study",
          options: [
            "school education",
            "Intermediate Courses",
            "Learn Language",
            "Curricular",
            "Competitive Exams",
            "IT Courses",
            "Special Kids (ADHD /ADD /AUTISM)",
          ],
          placeholder: "Select",
        },
        {
          type: "dropDown",
          name: "class",
          label: "For Which Class you need a Tutor ?",
          options: [],
          placeholder: "Select",
        },
        { type: "dropDown", name: "schoolBoard_stream", label: "School Board", options: [], placeholder: "Select" },
        { type: "dropDown", name: "course", label: "Course", options: [], placeholder: "Select" },
      ],
    },
    {
      section: "Tutor Requirements",
      fields: [
        {
          type: "dropDown",
          name: "preferredTutorGender",
          label: "Preferred Tutor Gender",
          options: ["I need only Male Tutor", "I need only Female Tutor", "Either Male or Female"],
          placeholder: "Select",
        },
        {
          type: "dropDown",
          name: "tuitionMode",
          label: "Mode of Tuition",
          options: ["Looking for Online Tutor", "Looking for Home Tutor", "Either Home/Online Tutor"],
          placeholder: "Select",
        },
        {
          type: "dropDown",
          name: "daysPerWeek",
          label: "Days per Week",
          options: [
            "1 Day a week",
            "2 Days a week",
            "3 Days a week",
            "4 Days a week",
            "5 Days a week",
            "6 Days a week",
          ],
          placeholder: "Select",
        },
        {
          type: "dropDown",
          name: "startDay",
          label: "When you would like to start ?",
          options: ["Immediately", "In Few Days", "In A Week", "In 10 Days", "In This Month", "Next Month"],
          placeholder: "Select",
        },
        {
          type: "text",
          name: "requirement_notes",
          label: "Req. notes",
          placeholder: "Enter notes for parents",
        },
      ],
    },
    {
      section: "Reference",
      fields: [
        {
          type: "dropDown",
          name: "reference",
          label: "where did you hear about us ?",
          options: ["Instagram", "Facebook", "LinkedIn", "Reference", "Google", "Youtube"],
          placeholder: "Select",
        },
      ],
    },
  ]);
  const [phoneType, setPhoneType] = useState("Phone");
  const phoneTypeOptions = ["Phone"];
  const [searchValue, setSearchValue] = useState("");
  const apiKey = (window._env_ && window._env_.REACT_APP_GOOGLE_MAPS_API_KEY) || process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const [selectedAddress, setSelectedAddress] = useState("");
  // useEffect(() => {
  //   form.setFieldValue("Lead Type","CALL");
  // },[])
  const [addressDetails, setAddressDetails] = useState({
    pincode: "",
    city: "",
    state: "",
    locality: "",
    latitude: "",
    longitude: "",
    gmap_meta_data: "",
    full_address: "",
  });
  const modeOfTutionconversion = {
    "Looking for Online Tutor": "online",
    online: "Looking for Online Tutor",
    "Looking for Home Tutor": "offline",
    offline: "Looking for Home Tutor",
    "Either Home/Online Tutor": "any",
    any: "Either Home/Online Tutor",
  };
  const genderConversion = {
    "I need only Male Tutor": "male",
    "I need only Female Tutor": "female",
    "Either Male or Female": "both",
    male: "I need only Male Tutor",
    female: "I need only Female Tutor",
    both: "Either Male or Female ",
  };

  const renderField = (field) => {
    // DropDown fields
    if (field.type === "dropDown") {
      return (
        // <Form.Item
        //   key={field.name}
        //   name={field.name}
        //   label={<span className="addNewDeal-form-fields">{field.label}</span>}
        //   rules={
        //     field.name === "class"
        //       ? [
        //           {
        //             validator: (_, value) => {
        //               const area = form.getFieldValue("areaOfStudy");
        //               if (
        //                 ["school education", "Intermediate Courses"].includes(area) &&
        //                 !value
        //               ) {
        //                 return Promise.reject(new Error("Please select a Class"));
        //               }
        //               return Promise.resolve();
        //             },
        //           },
        //         ]
        //       : []
        //   }
        // >
        <Form.Item
          key={field.name}
          name={field.name}
          label={<span className="addNewDeal-form-fields">{field.label}</span>}
          rules={
            field.name === "class"
              ? [
                  {
                    validator: (_, value) => {
                      const area = form.getFieldValue("areaOfStudy");
                      if (["school education", "Intermediate Courses"].includes(area) && !value) {
                        return Promise.reject(new Error("Please select a Class"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]
              : field.name === "reference"
              ? [
                  {
                    validator: (_, value) => {
                      if (!isReadonly && !value) {
                        return Promise.reject(new Error("Please enter a Reference"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]
              : []
          }
        >
          <Select
            disabled={(isReadonly && ["gender"].includes(field.name)) || (classReadonly && field.name === "class")}
            mode={field.name === "course" ? "multiple" : undefined}
            placeholder={field.placeholder}
            allowClear
            maxTagCount="responsive"
            // style={{ width: "400px", height: "40px" }}
            className="addNewDeal-form-select-fields"
            onChange={(value) => {
              if (field.name === "areaOfStudy") {
                fetchCourses(value);
              }
              if (field.name === "schoolBoard_stream") {
                handleStreamChange(value);
              }
              if (field.name === "class" && form.getFieldValue("areaOfStudy") === "school education") {
                handleClassChange(value); // Filtering logic for class
              }
            }}
          >
            {field.options.map((opt, idx) => (
              <Option key={idx} value={opt}>
                {opt}
              </Option>
            ))}
          </Select>
        </Form.Item>
      );
    }

    // Radio fields
    if (field.type === "radio") {
      return (
        <Form.Item
          initialValue={field.name === "Lead Type" ? "Call" : undefined}
          disabled={isReadonly}
          key={field.name}
          name={field.name}
          label={
            <span className="addNewDeal-form-fields" style={{ color: "#2179DF", fontSize: "16px", fontWeight: "600" }}>
              {field.label || field.name}
            </span>
          }
        >
          <Radio.Group>
            {field.options.map((opt, idx) => (
              <Radio key={idx} value={opt}>
                {opt}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      );
    }

    // Location field (Google Autocomplete)
    if (field.name === "location") {
      return (
        <Form.Item
          key={field.name}
          name={field.name}
          label={<span className="addNewDeal-form-fields">{field.label}</span>}
        >
          <ReactGoogleAutocomplete
            apiKey={apiKey}
            placeholder={field.placeholder}
            className="addNewDeal-form-autocomplete"
            // style={{ border:"1px solid #d9d9d9" ,paddingLeft:"10px" ,borderRadius:"6px"}}
            style={{
              display: "none",
            }}
            value={selectedAddress}
            onChange={(e) => {
              const val = e.target.value;
              setSelectedAddress(val);
              form.setFieldsValue({ location: val });
            }}
            onPlaceSelected={(place) => {
              if (!place.geometry) return;

              const addressComponents = place.address_components || [];

              // Helper to extract component by type
              const getComponent = (type) => {
                const comp = addressComponents.find((c) => c.types.includes(type));
                return comp ? comp.long_name : "";
              };

              const pincode = getComponent("postal_code");
              const city = getComponent("locality") || getComponent("administrative_area_level_2");
              const state = getComponent("administrative_area_level_1");
              const locality = getComponent("sublocality_level_1") || getComponent("locality");
              const adminCity = getComponent("administrative_area_level_2");

              // Keep the serviceable-city dropdown (city_name) in sync with the picked
              // address. Auto-select it when the detected city is serviceable; clear it
              // otherwise so a stale city is never submitted.
              form.setFieldsValue({ state: matchServiceableCity(city, adminCity, locality) || undefined });

              const latitude = place.geometry.location.lat();
              const longitude = place.geometry.location.lng();

              const formattedAddress = place.formatted_address || `${locality}, ${city}, ${state} - ${pincode}`;

              const gmap_meta_data = JSON.stringify(place);

              // Update Autocomplete field UI
              setSelectedAddress(place.formatted_address);
              form.setFieldsValue({ location: place.formatted_address });

              setAddressDetails({
                pincode,
                city,
                state,
                locality,
                latitude,
                longitude,
                gmap_meta_data,
                full_address: formattedAddress,
              });
            }}
            options={{
              types: [],
              componentRestrictions: { country: "IN" },
            }}
          />
          <ReactGoogleAutocomplete
            apiKey={apiKey}
            className="addNewDeal-form-autocomplete"
            style={{
              border: "1px solid #d9d9d9",
              paddingLeft: "10px",
              borderRadius: "6px",
              backgroundColor: "white",
              cursor: "text",
            }}
            placeholder={field.placeholder}
            defaultValue={selectedAddress}
            onChange={(e) => {
              setSelectedAddress(e.target?.value);
              form.setFieldsValue({ location: e.target?.value });
            }}
            onPlaceSelected={(place) => {
              setSelectedAddress(place.formatted_address);
              form.setFieldsValue({ location: place.formatted_address });
              const addressComponents = place.address_components || [];
              // Helper to extract component by type
              const getComponent = (type) => {
                const comp = addressComponents.find((c) => c.types.includes(type));
                return comp ? comp.long_name : "";
              };

              const pincode = getComponent("postal_code");
              const city = getComponent("locality") || getComponent("administrative_area_level_2");
              const state = getComponent("administrative_area_level_1");
              const locality = getComponent("sublocality_level_1") || getComponent("locality");
              const adminCity = getComponent("administrative_area_level_2");

              // Keep the serviceable-city dropdown (city_name) in sync with the picked
              // address. Auto-select it when the detected city is serviceable; clear it
              // otherwise so a stale city is never submitted.
              form.setFieldsValue({ state: matchServiceableCity(city, adminCity, locality) || undefined });

              const latitude = place.geometry.location.lat();
              const longitude = place.geometry.location.lng();

              const formattedAddress = place.formatted_address || `${locality}, ${city}, ${state} - ${pincode}`;

              const gmap_meta_data = JSON.stringify(place);
              setAddressDetails({
                pincode,
                city,
                state,
                locality,
                latitude,
                longitude,
                gmap_meta_data,
                full_address: formattedAddress,
              });
            }}
            options={{
              types: [],
              componentRestrictions: { country: "IN" },
            }}
          />
        </Form.Item>
      );
    }

    // Default input field
    return (
      <Form.Item
        key={field.name}
        name={field.name}
        label={<span className="addNewDeal-form-fields">{field.label}</span>}
      >
        <Input placeholder={field.placeholder} disabled={isReadonly} className="addNewDeal-form-select-fields" />
      </Form.Item>
    );
  };

  const fetchCourses = useCallback((catId) => {
    const areaOfStudy = form.getFieldValue("areaOfStudy");

    setClassReadonly(areaOfStudy === "school education" || areaOfStudy === "Intermediate Courses" ? false : true);
    axiosInstance
      .get("v1/student/all-courses?category_id=" + Categories[catId])
      .then((res) => {
        let data = res.data || [];

        setCourseData(data);

        // Reset dependent fields
        form.setFieldsValue({ schoolBoard_stream: [] });
        form.setFieldsValue({ course: [] });
        if (Categories[catId] === "4" || Categories[catId] === "1") {
          form.setFieldsValue({ class: [] });
        }

        setFormData((prev) =>
          prev.map((section) => {
            if (section.section === "Class Preference") {
              return {
                ...section,
                fields: section.fields.map((field) => {
                  // Clear course options
                  if (field.name === "course") {
                    return { ...field, options: [] };
                  }

                  // Update schoolBoard_stream
                  if (field.name === "schoolBoard_stream") {
                    return {
                      ...field,
                      label:
                        areaOfStudy === "school education" || areaOfStudy === "Intermediate Courses"
                          ? "Select the Board"
                          : "Select the Stream",
                      options: data.map((d) => d.stream_name),
                    };
                  }

                  // Update class options
                  if (field.name === "class") {
                    if (areaOfStudy === "school education") {
                      return {
                        ...field,
                        options: [
                          "Primary / Pre-Primary",
                          "LKG / UKG",
                          "1st Class",
                          "2nd Class",
                          "3rd Class",
                          "4th Class",
                          "5th Class",
                          "6th Class",
                          "7th Class",
                          "8th Class",
                          "9th Class",
                          "10th Class",
                        ],
                      };
                    } else if (areaOfStudy === "Intermediate Courses") {
                      return {
                        ...field,
                        options: ["11th Class", "12th Class"],
                      };
                    } else {
                      return { ...field, options: [] };
                    }
                  }

                  return field;
                }),
              };
            }
            return section;
          }),
        );
      })
      .catch((err) => console.error(err));
  }, []);

  const handleStreamChange = (streamName) => {
    const selectedStream = courseData.find((s) => s.stream_name === streamName);
    form.setFieldsValue({ course: [] });
    if (!selectedStream) return;

    const areaOfStudy = form.getFieldValue("areaOfStudy");

    setFormData((prev) =>
      prev.map((section) => {
        if (section.section === "Class Preference") {
          return {
            ...section,
            fields: section.fields.map((field) => {
              if (field.name === "course") {
                if (["school education", "Intermediate Courses"].includes(areaOfStudy)) {
                  // Leave empty for now — will be populated by handleClassChange
                  return { ...field, options: [] };
                }
                // Other categories → sorted immediately
                return { ...field, options: [...selectedStream.courses].sort((a, b) => a.length - b.length) };
              }
              return field;
            }),
          };
        }
        return section;
      }),
    );
    const selectedClass = form.getFieldValue("class");
    if (["school education", "Intermediate Courses"].includes(areaOfStudy) && selectedClass) {
      handleClassChange(selectedClass);
    }
  };
  // console.log(form.getFieldValue());
  const handleClassChange = (className) => {
    const selectedStreamName = form.getFieldValue("schoolBoard_stream");
    const selectedStream = courseData.find((s) => s.stream_name === selectedStreamName);
    if (!selectedStream) return;

    let coursesList = [...selectedStream.courses].sort((a, b) => a.length - b.length);

    if (["Primary / Pre-Primary", "LKG / UKG"].includes(className)) {
      coursesList = ["All Subjects"];
    } else if (
      ["1st Class", "2nd Class", "3rd Class", "4th Class", "5th Class", "6th Class", "7th Class"].includes(className)
    ) {
      coursesList = coursesList.filter(
        (course) =>
          ![
            "All Subjects",
            "All Subjects Except Language",
            "Physics",
            "Chemistry",
            "Biology",
            "History",
            "Geography",
            "Political Science",
          ].includes(course),
      );
      coursesList = ["All Subjects", "All Subjects Except Language", ...coursesList];
    } else if (["8th Class", "9th Class", "10th Class"].includes(className)) {
      coursesList = coursesList.filter((course) => !["All Subjects", "All Subjects Except Language"].includes(course));
    } else if (["11th Class", "12th Class"].includes(className)) {
      coursesList = coursesList.filter((course) => !["Science", "Accountancy"].includes(course));
    }

    // Auto-clear course selection in form
    form.setFieldsValue({ course: [] });

    // Update formData with filtered course list
    setFormData((prev) =>
      prev.map((section) => {
        if (section.section === "Class Preference") {
          return {
            ...section,
            fields: section.fields.map((field) =>
              field.name === "course" ? { ...field, options: coursesList } : field,
            ),
          };
        }
        return section;
      }),
    );
  };
  const handleSubmit = () => {
    const values = form.getFieldsValue();
    for (let [key, value] of Object.entries(values)) {
      if (key === "class" || key === "reference" || key === "requirement_notes") continue;
      if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
        message.error(`Please fill in the "${key}" field.`);
        return;
      }
    }

    // Phone validation
    if (!/^\d{10}$/.test(values.mobile)) {
      message.error("Phone number must be exactly 10 digits.");
      return; // Stop submit
    }

    // --- Payload creation ---
    let payload = {};
    const category_id = Categories[values.areaOfStudy];

    if (category_id === "1" || category_id === "4") {
      payload = {
        level: values.class,
        category_id: ["11th Class", "12th Class"].includes(values.class) ? "4" : "1",
      };
    } else {
      payload = {
        category_id,
        level: "Advanced Level",
      };
    }

    payload = {
      ...payload,
      first_name: values.firstName,
      last_name: values.lastName,
      gender: values.gender,
      phone: values.mobile,
      email: values.email,
      latitude: addressDetails.latitude || "",
      longitude: addressDetails.longitude || "",
      qualification: values.qualification || "",
      reference: values.reference || "",
      course: values.course || "",
      tutor_gender_preference: genderConversion[values.preferredTutorGender] || values.preferredTutorGender,
      days_per_week: values.daysPerWeek || "",
      when_to_start: values.startDay || "",
      mode_of_tution: modeOfTutionconversion[values.tuitionMode] || values.tutitionMode,
      stream_id: values.schoolBoard_stream || "",
      gmap_meta_data: addressDetails.gmap_meta_data || "",
      requirement_notes: values.requirement_notes || "",
      city_name: values.state || "",
      state_name: addressDetails.state || "",
      locality: addressDetails.locality || "",
      zip: addressDetails.pincode || "",
      created_from: "CALL",
      userId: form.getFieldValue("userId"),
    };
    // console.log("Final Payload:", payload);
    // console.log("formdata", form.getFieldsValue());
    Modal.confirm({
      title: "Confirm Submission",
      content: "Are you sure you want to submit the form? Make sure all the details are correct.",
      okText: "Yes, Submit",
      cancelText: "Cancel",
      onOk: () => {
        setFormLoading(true);
        axiosInstance
          .post("v1/cre/add-new-deal", payload)
          .then((res) => {
            if (res.data === "error while creating new Deal") {
              message.error("Error submitting form");
              setFormLoading(false);
            } else {
              message.success("Form submitted successfully");
              setFormLoading(false);
              setIsReadonly(false);
              form.resetFields();
            }
          })
          .catch((err) => {
            setFormLoading(false);
            console.error("Error submitting form:", err);
            message.error("Error submitting form");
          });
      },
      onCancel: () => {
        setFormLoading(false);
      },
    });
  };

  const handleSearchUser = async () => {
    try {
      if (!searchValue) {
        message.warning("Please enter a value to search");
        return;
      }

      if (!/^\d{10}$/.test(searchValue)) {
        message.error("Please enter a valid 10 digit mobile number");
        return;
      }

      setLoading(true);
      form.resetFields();
      const res = await axiosInstance.get(`v1/cre/StudentDetails-for-new-deal?phone=${searchValue}`);

      if (res.data?.data) {
        let userData = { ...res.data.data };

        // Location comes in combined format like "<--><--><-->Ahmedabad"
        // For the form and autocomplete we only want the final address part.
        if (userData.location) {
          const parts = userData.location.split("<-->");
          const lastPart = parts[parts.length - 1].trim();
          userData.location = lastPart;
          setSelectedAddress(lastPart);
        } else {
          setSelectedAddress("");
        }
        if (userData.city_id && citys[userData.city_id]) {
          userData.state = citys[userData.city_id];
        }
        form.setFieldsValue(userData);
        setIsReadonly(true);
        message.success("User details loaded successfully");
      } else {
        form.resetFields();
        setIsReadonly(false);
        message.error("No user found");
      }
    } catch (error) {
      console.error(error);
      const errorMsg = error.response?.data?.message || "Error fetching user details";
      message.error(errorMsg);
      setIsReadonly(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="addNewDeal-container">
      {/* Search */}
      <div className="addNewDeal-search-container">
        <Select value={phoneType} style={{ width: 120 }} onChange={(val) => setPhoneType(val)}>
          {phoneTypeOptions.map((opt, index) => (
            <Option key={index} value={opt}>
              {opt}
            </Option>
          ))}
        </Select>
        <Input.Search
          placeholder="Search"
          enterButton
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onSearch={handleSearchUser}
          loading={loading}
          style={{ width: 300 }}
        />
      </div>

      {/* Form */}
      <Spin spinning={formLoading} tip="Submitting...">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          loading={formLoading}
          className="addNewDeal-container-form"
        >
          {formData.slice(0, 2).map((section, idx) => (
            <div key={idx}>
              {section.section && <Title className="Title">{section.section}</Title>}
              <Row gutter={16}>
                {(section.fields || [section]).map((field, index) => (
                  <Col span={8} key={index}>
                    {renderField(field)}
                  </Col>
                ))}
              </Row>
            </div>
          ))}

          {formData.slice(2, 3).map((section, idx) => (
            <div key={idx}>
              {section.section && <Title className="Title">{section.section}</Title>}

              <Row gutter={16}>
                {(section.fields || [section]).map((field, index) => {
                  if (
                    !["school education", "Intermediate Courses"].includes(form.getFieldValue("areaOfStudy")) &&
                    field.name === "class"
                  )
                    return null;
                  return (
                    <Col span={8} key={index}>
                      {renderField(field)}
                    </Col>
                  );
                })}
              </Row>
            </div>
          ))}

          {formData.slice(3).map((section, idx) => {
            if (isReadonly && section.section === "Reference") {
              return null;
            }

            return (
              <div key={idx}>
                {section.section && <Title className="Title">{section.section}</Title>}
                <Row gutter={16}>
                  {(section.fields || [section]).map((field, index) => (
                    <Col span={8} key={index}>
                      {renderField(field)}
                    </Col>
                  ))}
                </Row>
              </div>
            );
          })}

          <div className="addNewDeal-container-form-buttons-div">
            <Form.Item>
              <Button type="primary" htmlType="submit" block className="addNewDeal-container-form-buttons">
                Submit
              </Button>
            </Form.Item>
            <Form.Item>
              <Popconfirm
                title="Clear the form"
                description="This will remove all entered details. Continue?"
                okText="Yes, Clear"
                cancelText="No"
                onConfirm={() => {
                  form.resetFields();
                  setSelectedAddress("");
                  setIsReadonly(false);
                  message.success("Form cleared");
                }}
                onCancel={() => message.info("Clear cancelled")}
              >
                <Button danger block className="addNewDeal-container-form-buttons">
                  Clear Form
                </Button>
              </Popconfirm>
            </Form.Item>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default AddNewDeal;
